<script lang="ts">
  // Components
  import { Grid } from '$lib/components/organisms/Layout';

  export let backgroundSrc: string
  export let data
</script>

<section class="section-image" style="background-image: url({backgroundSrc})">
  <Grid>
    <div class="section-image-content">
      <span class="subtitle">{data.subtitle}</span>
      <h2 class="title">{data.title}</h2>
      <p class="description">{data.description}</p>
      <slot name="action" />
    </div>
  </Grid>
</section>

<style type="text/scss" lang="scss" scoped>
  .section-image {
    @apply relative;
    @apply min-h-[500px];
    @apply bg-cover bg-center bg-no-repeat;
    @apply flex items-center;
    @apply page-max-width;

    &::before {
      content: "";
      @apply absolute inset-0;
      @apply bg-black bg-opacity-30;
      @apply mix-blend-multiply;
    }
  }

  .section-image-content {
    @apply col-span-full;
    @apply md:col-start-3 md:col-span-8;
    @apply lg:col-start-4 lg:col-span-6;
    @apply flex flex-col items-center;
    @apply text-white text-center;
    @apply p-5;
    @apply z-0;
  }

  .subtitle {
    @apply text-base uppercase tracking-wider text-opacity-70 text-white;
    @apply mb-2;
  }

  .title {
    @apply text-white md:text-4xl lg:text-6xl;
    @apply mb-3;
  }

  .description {
    @apply text-white;
    @apply mb-6;
  }
</style>
